export const GetBaseURL = () => {
  return process.env.REACT_APP_BASE_URL;
};

export const GetPushState: (login: boolean) => string = (login: boolean) => {
  return login ? process.env.REACT_APP_LOGIN_PUSH_STATE! : process.env.REACT_APP_LOGOUT_PUSH_STATE!;
};
